
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2kPmq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $fMSL7 = parcelRequire("fMSL7");

const $0d6e428976b1cdda$var$Context = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $0d6e428976b1cdda$export$6833e312d94b56fb = ({ scope: input, children: children })=>{
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const resolution = (0, $fMSL7.useRovoActivationId)(input);
    const activationId = resolution.status === 'ready' ? resolution.rovoActivationId : undefined;
    const reason = resolution.status === 'unavailable' ? resolution.reason : undefined;
    const accountId = input.accountId.trim();
    const cloudId = input.cloudId?.trim();
    const enableExplicitAgentSessionSubscriptionSharding = input.enableExplicitAgentSessionSubscriptionSharding === true;
    const value = (0, $cozmU.useMemo)(()=>({
            environment: environment,
            input: cloudId ? {
                accountId: accountId,
                cloudId: cloudId
            } : {
                accountId: accountId,
                rovoActivationId: activationId ?? ''
            },
            scope: activationId ? {
                accountId: accountId,
                cloudId: cloudId,
                rovoActivationId: activationId,
                workspaceAri: `ari:cloud:rovo::workspace/${activationId}`,
                ...enableExplicitAgentSessionSubscriptionSharding ? {
                    enableExplicitAgentSessionSubscriptionSharding: enableExplicitAgentSessionSubscriptionSharding
                } : {}
            } : null,
            reason: reason
        }), [
        accountId,
        activationId,
        enableExplicitAgentSessionSubscriptionSharding,
        cloudId,
        environment,
        reason
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0d6e428976b1cdda$var$Context.Provider, {
        value: value
    }, children);
};
const $0d6e428976b1cdda$export$4b4041930ceb1eb0 = ()=>{
    const context = (0, $cozmU.useContext)($0d6e428976b1cdda$var$Context);
    if (!context) throw new Error('AgentSessionsScopeProvider is required.');
    return context;
};
const $0d6e428976b1cdda$export$21121a081bdaa23e = (scope)=>JSON.stringify([
        scope.accountId,
        scope.workspaceAri
    ]);
module.exports["AgentSessionsScopeProvider"] = $0d6e428976b1cdda$export$6833e312d94b56fb;
module.exports["useAgentSessionsScope"] = $0d6e428976b1cdda$export$4b4041930ceb1eb0;
module.exports["getAgentSessionsScopeKey"] = $0d6e428976b1cdda$export$21121a081bdaa23e;

});

parcelRegister("fMSL7", function(module, exports) {

var $hpS8X = parcelRequire("hpS8X");


var $6SsN4 = parcelRequire("6SsN4");

const $9051c004a0b895c2$var$getNonEmptyString = (value)=>{
    return typeof value === 'string' && value.trim() ? value.trim() : undefined;
};
const $9051c004a0b895c2$export$affe63e2fd1baa55 = ({ accountId: accountId, cloudId: cloudId, rovoActivationId: rovoActivationId })=>{
    const validAccountId = $9051c004a0b895c2$var$getNonEmptyString(accountId);
    const suppliedActivationId = $9051c004a0b895c2$var$getNonEmptyString(rovoActivationId);
    const validCloudId = $9051c004a0b895c2$var$getNonEmptyString(cloudId);
    const shouldResolveActivation = validAccountId != null && validCloudId != null;
    // eslint-disable-next-line @atlassian/relay/no-wrapping-hooks -- Workspace discovery is an internal part of the public sessions hook.
    const activationData = (0, $6SsN4.useLazyLoadQuery)((0, $hpS8X.default), {
        cloudId: validCloudId ?? '',
        shouldResolveActivation: shouldResolveActivation
    }, {
        fetchPolicy: 'store-or-network'
    });
    if (validAccountId == null || suppliedActivationId == null && validCloudId == null) return {
        status: 'unavailable',
        reason: 'missing-identity'
    };
    if (validCloudId == null && suppliedActivationId != null) return {
        status: 'ready',
        rovoActivationId: suppliedActivationId
    };
    const resolvedActivationId = $9051c004a0b895c2$var$getNonEmptyString(activationData.tenantContexts?.[0]?.activationIdByProduct?.active);
    return resolvedActivationId == null ? {
        status: 'unavailable',
        reason: 'no-active-rovo-activation'
    } : {
        status: 'ready',
        rovoActivationId: resolvedActivationId
    };
};
module.exports["useRovoActivationId"] = $9051c004a0b895c2$export$affe63e2fd1baa55;

});

parcelRegister("hpS8X", function(module, exports) {
/**
 * @generated SignedSource<<ea4a67cd799b583111f2a0e97bc696ce>>
 * @relayHash 348979b6d4852cfc2dcc9cbeaa57e107
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 68c72f13a01f2451f188338225b4019f758a8369e559f30beb6142c690fb05bb
const $7f3d7b18a4cb51a1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldResolveActivation"
        }
    ], v1 = [
        {
            "condition": "shouldResolveActivation",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "items": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudIds.0",
                                    "variableName": "cloudId"
                                }
                            ],
                            "kind": "ListValue",
                            "name": "cloudIds"
                        }
                    ],
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "product",
                                    "value": "rovo"
                                }
                            ],
                            "concreteType": "TenantContextActivationId",
                            "kind": "LinkedField",
                            "name": "activationIdByProduct",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "active"
                                }
                            ],
                            "storageKey": "activationIdByProduct(product:\"rovo\")"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useRovoActivationIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useRovoActivationIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "68c72f13a01f2451f188338225b4019f758a8369e559f30beb6142c690fb05bb",
            "metadata": {},
            "name": "useRovoActivationIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7f3d7b18a4cb51a1$var$node.hash = "7c2eb7120d071cce4386ff814335ec18";
var $7f3d7b18a4cb51a1$export$2e2bcd8739ae039 = $7f3d7b18a4cb51a1$var$node;
module.exports["default"] = $7f3d7b18a4cb51a1$export$2e2bcd8739ae039;

});

parcelRegister("aHzov", function(module, exports) {

var $6SsN4 = parcelRequire("6SsN4");


var $hlvTd = parcelRequire("hlvTd");


var $eFNzw = parcelRequire("eFNzw");


var $aPWgL = parcelRequire("aPWgL");


var $2kPmq = parcelRequire("2kPmq");


var $fzdMm = parcelRequire("fzdMm");

class $25a799cf05eedfb4$export$30a7cd537898738b {
    updateScope(scope) {
        if (!this.scope.cloudId && scope.cloudId) this.scope = scope;
    }
    get revision() {
        return this.sequence;
    }
    get continuous() {
        return this.started && !this.uncertain;
    }
    emit(event) {
        if (event.kind === 'session') (0, $aPWgL.getAgentSessionReconciliation)(this.environment, this.scope).event(event);
        for (const observer of this.observers)observer(event);
    }
    connect(generation) {
        const valid = ()=>this.started && this.generation === generation;
        const start = (cloudId)=>{
            if (!valid() || !cloudId || this.transport) return;
            const attempt = ++this.transportGeneration;
            const isCurrent = ()=>valid() && attempt === this.transportGeneration;
            const variables = {
                accountId: this.scope.accountId,
                workspaceAri: this.scope.workspaceAri,
                cloudId: cloudId
            };
            const next = (data)=>{
                if (!isCurrent()) return;
                // AGG can emit subscription metadata without a domain payload.
                // Transport errors still arrive through onError.
                if (data == null) return;
                const change = data.convoai_onInboxSessionChanged;
                if (!change || change.session === undefined || !change.sessionId || !change.sessionAri || change.session && change.session.id !== change.sessionId) {
                    this.recover('error');
                    return;
                }
                this.uncertain = false;
                this.emit({
                    kind: 'session',
                    sequence: ++this.sequence,
                    receivedAt: Date.now(),
                    sessionId: change.sessionId,
                    sessionAri: change.sessionAri,
                    session: change.session
                });
            };
            const error = (exception)=>{
                if (!isCurrent()) return;
                ++this.transportGeneration;
                this.uncertain = true;
                const transport = this.transport;
                this.transport = undefined;
                transport?.dispose();
                (0, $hlvTd.logException)({
                    name: 'agentSessionEventSource',
                    exception: exception
                });
                this.recover('error');
            };
            let payload;
            const transport = (0, $6SsN4.requestSubscription)(this.environment, {
                subscription: $eFNzw.agentSessionEventsSubscription,
                variables: variables,
                cacheConfig: this.scope.enableExplicitAgentSessionSubscriptionSharding ? {
                    metadata: {
                        subscriptionShardingContext: {
                            type: 'workspace',
                            product: 'rovo',
                            workspaceId: this.scope.rovoActivationId
                        }
                    }
                } : undefined,
                updater: (_store, data)=>{
                    payload = data;
                },
                onNext: ()=>{
                    const data = payload;
                    payload = undefined;
                    next(data);
                },
                onError: error,
                onCompleted: ()=>error(new Error('AgentSession subscription completed.'))
            });
            if (isCurrent()) {
                this.transport = transport;
                this.uncertain = !navigator.onLine;
            } else transport.dispose();
        };
        if (this.scope.cloudId) start(this.scope.cloudId);
        else {
            this.lookup?.dispose();
            this.lookup = (0, $fzdMm.resolveAgentSessionsCloudId)(this.environment, {
                rovoActivationId: this.scope.rovoActivationId,
                onComplete: ({ cloudId: cloudId })=>{
                    if (!valid()) return;
                    if (cloudId) start(cloudId);
                    else {
                        this.uncertain = true;
                        this.recover('error');
                    }
                }
            });
        }
    }
    observe(observer) {
        clearTimeout(this.disposal);
        this.disposal = undefined;
        const listener = (event)=>observer(event);
        this.observers.add(listener);
        if (!this.started && !this.environment.isServer() && typeof window !== 'undefined') {
            this.started = true;
            this.connect(++this.generation);
            window.addEventListener('online', this.online);
            window.addEventListener('offline', this.offline);
            document.addEventListener('visibilitychange', this.visible);
        } else if (this.started && !this.transport && this.uncertain && navigator.onLine) this.connect(this.generation);
        let disposed = false;
        return {
            dispose: ()=>{
                if (disposed) return;
                disposed = true;
                this.observers.delete(listener);
                if (this.observers.size || this.disposal != null || !this.started) return;
                const generation = this.generation;
                this.disposal = setTimeout(()=>{
                    this.disposal = undefined;
                    if (this.observers.size || generation !== this.generation) return;
                    this.started = false;
                    this.uncertain = true;
                    ++this.sequence;
                    ++this.generation;
                    this.transport?.dispose();
                    this.transport = undefined;
                    this.lookup?.dispose();
                    this.lookup = undefined;
                    window.removeEventListener('online', this.online);
                    window.removeEventListener('offline', this.offline);
                    document.removeEventListener('visibilitychange', this.visible);
                }, 1000);
            }
        };
    }
    constructor(environment, scope){
        this.environment = environment;
        this.scope = scope;
        this.observers = new Set();
        this.transport = void 0;
        this.lookup = void 0;
        this.disposal = void 0;
        this.generation = 0;
        this.transportGeneration = 0;
        this.sequence = 0;
        this.uncertain = true;
        this.started = false;
        this.recover = (reason)=>{
            this.emit({
                kind: 'recovery',
                reason: reason,
                sequence: ++this.sequence
            });
        };
        this.online = ()=>{
            if (!this.transport) this.connect(this.generation);
            this.recover('online');
        };
        this.offline = ()=>{
            this.uncertain = true;
        };
        this.visible = ()=>{
            if (document.visibilityState === 'visible' && this.uncertain && navigator.onLine) {
                if (!this.transport) this.connect(this.generation);
                this.recover('visible');
            }
        };
    }
}
const $25a799cf05eedfb4$var$sources = new WeakMap();
const $25a799cf05eedfb4$export$1adece231411b7fc = (environment, scope)=>{
    let scopes = $25a799cf05eedfb4$var$sources.get(environment);
    if (!scopes) {
        scopes = new Map();
        $25a799cf05eedfb4$var$sources.set(environment, scopes);
    }
    const key = (0, $2kPmq.getAgentSessionsScopeKey)(scope);
    let source = scopes.get(key);
    if (!source) {
        source = new $25a799cf05eedfb4$export$30a7cd537898738b(environment, scope);
        scopes.set(key, source);
    }
    source.updateScope(scope);
    return source;
};
module.exports["getAgentSessionEventSource"] = $25a799cf05eedfb4$export$1adece231411b7fc;

});

parcelRegister("eFNzw", function(module, exports) {

var $g0I4G = parcelRequire("g0I4G");

const $7b4ca763058be686$export$b0785ce9e428410c = (0, $g0I4G.default);
module.exports["agentSessionEventsSubscription"] = $7b4ca763058be686$export$b0785ce9e428410c;

});

parcelRegister("g0I4G", function(module, exports) {
/**
 * @generated SignedSource<<8fd729ff47e0177682fafd5ba90c46dd>>
 * @relayHash 97ed2cb90f505ce9eb3a2a7043ca9b1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c6f64a7f4d8698d9adb6e3fba7a4f0323512cccaa3036d4689fdda474df7ca21
const $9b365cb4540b445b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "workspaceAri"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "accountId"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "workspaceAri",
                    "variableName": "workspaceAri"
                }
            ],
            "concreteType": "ConvoAiInboxSessionChanged",
            "kind": "LinkedField",
            "name": "convoai_onInboxSessionChanged",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "sessionId"
                },
                {
                    "kind": "ScalarField",
                    "name": "sessionAri"
                },
                {
                    "concreteType": "AgentSession",
                    "kind": "LinkedField",
                    "name": "session",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasUnseenActivity"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "invocationType"
                        },
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "state"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "stateReason"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "expireTime"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "lastStateChangeAt"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isRovo"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "agentAccountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "convoAiAgentId"
                        },
                        {
                            "alias": "conversationChannel",
                            "concreteType": "AgentConversationChannel",
                            "kind": "LinkedField",
                            "name": "nativeConversationChannel",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "createdAt"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "interactionChannel"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "interactionChannelAri"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "rawAgent"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "rawScopes"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "rawParticipants"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "rawAgentAuthor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastMessage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastMessageTimestamp"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastMessageType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastAgentMessageId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastAgentMessageStatus"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "readStatus"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isPlanning"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isPinned"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "pinnedAt"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "agentSessionEventsSubscription",
            "selections": v2 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "agentSessionEventsSubscription",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "c6f64a7f4d8698d9adb6e3fba7a4f0323512cccaa3036d4689fdda474df7ca21",
            "metadata": {},
            "name": "agentSessionEventsSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$9b365cb4540b445b$var$node.hash = "0a85066b3c819a1c08606ccd13bc9662";
var $9b365cb4540b445b$export$2e2bcd8739ae039 = $9b365cb4540b445b$var$node;
module.exports["default"] = $9b365cb4540b445b$export$2e2bcd8739ae039;

});

parcelRegister("aPWgL", function(module, exports) {

var $eqEJl = parcelRequire("eqEJl");


var $bJzbV = parcelRequire("bJzbV");


var $lvIcu = parcelRequire("lvIcu");


var $iQweE = parcelRequire("iQweE");


var $2kPmq = parcelRequire("2kPmq");

const $1f956776dca188bc$export$3bd9d720f26bfe44 = (node, now)=>node.hasUnseenActivity === true && typeof node.lastStateChangeAt === 'number' && Number.isFinite(node.lastStateChangeAt) && node.lastStateChangeAt <= now && node.lastStateChangeAt >= now - (0, $iQweE.UNSEEN_WINDOW_MS);
// Read the transaction's records, including fields just normalized by an overlapping query.
// A selected null is complete; only missing selected fields require hydration.
const $1f956776dca188bc$var$hasSelections = (node, selections)=>selections.every((selection)=>{
        if (selection.kind === 'ScalarField') return node.getValue(selection.name) !== undefined;
        if (selection.kind === 'LinkedField') {
            if (selection.plural) {
                const records = node.getLinkedRecords(selection.name);
                return records !== undefined && (records === null || records.every((record)=>record === null || record !== undefined && $1f956776dca188bc$var$hasSelections(record, selection.selections)));
            }
            const record = node.getLinkedRecord(selection.name);
            return record !== undefined && (record === null || $1f956776dca188bc$var$hasSelections(record, selection.selections));
        }
        if (selection.kind === 'InlineFragment') return selection.type !== node.getType() || $1f956776dca188bc$var$hasSelections(node, selection.selections);
        return false;
    });
const $1f956776dca188bc$export$83f6c925be1ddf3 = (store, sessionId)=>{
    const node = store.get((0, $bJzbV.default)({
        id: sessionId
    }, 'AgentSession'));
    return Boolean(node && $1f956776dca188bc$var$hasSelections(node, (0, $eqEJl.getFragment)((0, $lvIcu.agentSessionSnapshot)).selections));
};
const $1f956776dca188bc$export$3e45b673ac1471f = (store, policy, sessionId, remove, canInsert, now)=>{
    const connection = (0, $eqEJl.ConnectionHandler).getConnection(store.getRoot(), policy.key, policy.filters);
    if (!connection) return;
    const node = store.get((0, $bJzbV.default)({
        id: sessionId
    }, 'AgentSession'));
    const edges = connection.getLinkedRecords('edges') ?? [];
    const existing = edges.find((edge)=>edge?.getLinkedRecord('node')?.getValue('id') === sessionId);
    const dataID = node?.getDataID() ?? existing?.getLinkedRecord('node')?.getDataID();
    if (!dataID) return;
    const unseen = node && $1f956776dca188bc$export$3bd9d720f26bfe44({
        hasUnseenActivity: node.getValue('hasUnseenActivity'),
        lastStateChangeAt: node.getValue('lastStateChangeAt')
    }, now);
    if (remove || !node || !policy.includeLocal && node.getValue('invocationType') === 'LOCAL_AGENT_SESSION' || policy.unseen && !unseen) {
        (0, $eqEJl.ConnectionHandler).deleteNode(connection, dataID);
        return;
    }
    if (!existing && (!canInsert || !policy.includeLocal && node.getValue('invocationType') == null)) return;
    let edge = existing;
    if (!edge) {
        edge = (0, $eqEJl.ConnectionHandler).createEdge(store, connection, node, 'AgentSessionEdge');
        edge.setValue(null, 'cursor');
    }
    const ordered = edges.filter((item)=>item != null && item.getLinkedRecord('node')?.getDataID() !== dataID);
    const timestamp = node.getValue('lastStateChangeAt');
    if (typeof timestamp !== 'number' || !Number.isFinite(timestamp)) return;
    // Existing ties keep their position; a new tie follows the already-known rows.
    const oldIndex = existing ? edges.indexOf(existing) : Number.MAX_SAFE_INTEGER;
    let index = ordered.findIndex((item, i)=>{
        const other = item.getLinkedRecord('node')?.getValue('lastStateChangeAt');
        return typeof other !== 'number' || other < timestamp || other === timestamp && i >= oldIndex;
    });
    if (index < 0) index = ordered.length;
    ordered.splice(index, 0, edge);
    connection.setLinkedRecords(ordered.slice(0, policy.extent), 'edges');
};
const $1f956776dca188bc$var$writeEvent = (store, event)=>{
    if (!event.session) return;
    const id = (0, $bJzbV.default)({
        id: event.sessionId
    }, 'AgentSession');
    const node = store.get(id) ?? store.create(id, 'AgentSession');
    const { conversationChannel: conversationChannel } = event.session;
    for (const key of [
        'id',
        'state',
        'stateReason',
        'expireTime',
        'lastStateChangeAt',
        'isRovo',
        'agentAccountId',
        'convoAiAgentId',
        'hasUnseenActivity',
        'invocationType'
    ]){
        const value = event.session[key];
        if (value !== undefined) node.setValue(value, key);
    }
    if (conversationChannel === null) node.setValue(null, 'nativeConversationChannel');
    else if (conversationChannel) {
        const channelID = conversationChannel.id ? (0, $bJzbV.default)({
            id: conversationChannel.id
        }, 'AgentConversationChannel') : node.getLinkedRecord('nativeConversationChannel')?.getDataID() ?? `${id}:nativeConversationChannel`;
        const channel = store.get(channelID) ?? store.create(channelID, 'AgentConversationChannel');
        for (const [key, value] of Object.entries(conversationChannel)){
            if (value === undefined) continue;
            // These schema-declared JSON scalars can contain objects and arrays of objects.
            if (key === 'rawAgent' || key === 'rawScopes' || key === 'rawParticipants' || key === 'rawAgentAuthor') channel.setValue__UNSAFE(value, key);
            else if (value === null || typeof value !== 'object' || Array.isArray(value)) channel.setValue(value, key);
        }
        node.setLinkedRecord(channel, 'nativeConversationChannel');
    }
};
class $1f956776dca188bc$export$dde18cd5f0ae1b96 {
    addHandler(handler) {
        this.handlers.add(handler);
        return {
            dispose: ()=>{
                this.handlers.delete(handler);
            }
        };
    }
    current(sessionId) {
        return this.latest.get(sessionId);
    }
    event(event) {
        const deleted = this.deleted.get(event.sessionId);
        if (deleted) {
            this.environment.commitUpdate(this.apply([
                deleted
            ]));
            return;
        }
        if (event.session === null) this.deleted.set(event.sessionId, event);
        if ((this.latest.get(event.sessionId)?.sequence ?? -1) >= event.sequence) return;
        this.latest.set(event.sessionId, {
            sequence: event.sequence,
            removed: event.session === null
        });
        this.environment.commitUpdate(this.apply([
            event
        ]));
        if (this.operations.size) {
            this.journal.set(event.sessionId, event);
            this.refreshOverlay();
        }
    }
    refreshOverlay() {
        const previous = this.overlay;
        this.overlay = this.environment.applyUpdate({
            storeUpdater: this.apply([
                ...this.journal.values()
            ])
        });
        previous?.dispose();
    }
    begin(seed) {
        const operation = Symbol('agent-session-operation');
        this.operations.add(operation);
        if (this.deleted.size) {
            for (const [id, event] of this.deleted)this.journal.set(id, event);
            this.refreshOverlay();
        }
        // Hydration starts because of this event, so it must not overwrite that event's fields.
        if (seed && this.latest.get(seed.sessionId)?.sequence === seed.sequence) {
            this.journal.set(seed.sessionId, seed);
            this.refreshOverlay();
        }
        return {
            dispose: ()=>{
                if (!this.operations.delete(operation) || this.operations.size) return;
                if (this.journal.size) this.environment.commitUpdate(this.apply([
                    ...this.journal.values()
                ]));
                this.overlay?.dispose();
                this.overlay = undefined;
                this.journal.clear();
            }
        };
    }
    constructor(environment){
        this.environment = environment;
        this.operations = new Set();
        this.journal = new Map();
        this.latest = new Map();
        this.deleted = new Map();
        this.handlers = new Set();
        this.overlay = void 0;
        this.apply = (events)=>(store)=>{
                for (const event of events){
                    $1f956776dca188bc$var$writeEvent(store, event);
                    this.handlers.forEach((handler)=>handler(store, event));
                    if (event.session === null) {
                        const id = (0, $bJzbV.default)({
                            id: event.sessionId
                        }, 'AgentSession');
                        const channel = store.get(id)?.getLinkedRecord('nativeConversationChannel');
                        if (channel) store.delete(channel.getDataID());
                        store.delete((0, $bJzbV.default)({
                            id: event.sessionId
                        }, 'AgentConversationChannel'));
                        store.delete(id);
                    }
                }
            };
    }
}
const $1f956776dca188bc$var$environments = new WeakMap();
const $1f956776dca188bc$export$543baa33849c24da = (environment, scope)=>{
    let scopes = $1f956776dca188bc$var$environments.get(environment);
    if (!scopes) {
        scopes = new Map();
        $1f956776dca188bc$var$environments.set(environment, scopes);
    }
    const key = (0, $2kPmq.getAgentSessionsScopeKey)(scope);
    let resource = scopes.get(key);
    if (!resource) {
        resource = new $1f956776dca188bc$export$dde18cd5f0ae1b96(environment);
        scopes.set(key, resource);
    }
    return resource;
};
module.exports["isKnownUnseen"] = $1f956776dca188bc$export$3bd9d720f26bfe44;
module.exports["hasAgentSessionDisplay"] = $1f956776dca188bc$export$83f6c925be1ddf3;
module.exports["reconcileAgentSessionConnection"] = $1f956776dca188bc$export$3e45b673ac1471f;
module.exports["getAgentSessionReconciliation"] = $1f956776dca188bc$export$543baa33849c24da;

});

parcelRegister("lvIcu", function(module, exports) {

var $hC2b3 = parcelRequire("hC2b3");

const $fcc30fb3b9c7ce24$export$9ac007265ccf882f = (0, $hC2b3.default);
module.exports["agentSessionSnapshot"] = $fcc30fb3b9c7ce24$export$9ac007265ccf882f;

});

parcelRegister("hC2b3", function(module, exports) {
/**
 * @generated SignedSource<<45b20589324b434329ec85d6987cf474>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5581ee50265daf0c$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    }, v2 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "agentSessionSnapshot_session",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "state"
            },
            {
                "kind": "ScalarField",
                "name": "stateReason"
            },
            {
                "kind": "ScalarField",
                "name": "expireTime"
            },
            {
                "kind": "ScalarField",
                "name": "lastStateChangeAt"
            },
            {
                "kind": "ScalarField",
                "name": "isRovo"
            },
            {
                "kind": "ScalarField",
                "name": "agentAccountId"
            },
            {
                "kind": "ScalarField",
                "name": "convoAiAgentId"
            },
            {
                "alias": "conversationChannel",
                "concreteType": "AgentConversationChannel",
                "kind": "LinkedField",
                "name": "nativeConversationChannel",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "createdAt"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "interactionChannel"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "interactionChannelAri"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "rawAgent"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "rawScopes"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "rawParticipants"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "rawAgentAuthor"
                    },
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "lastMessage"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "lastMessageTimestamp"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "lastMessageType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "lastAgentMessageId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "lastAgentMessageStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "readStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isPlanning"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isPinned"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "pinnedAt"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "status"
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                    v2 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "picture"
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    v2 /*: any*/ ,
                    v1 /*: any*/ 
                ]
            },
            {
                "kind": "LinkedField",
                "name": "studioAgent",
                "plural": false,
                "selections": [
                    v1 /*: any*/ 
                ]
            },
            {
                "kind": "LinkedField",
                "name": "associatedEntities",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "webUrl"
                            }
                        ],
                        "type": "JiraIssue"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v0 /*: any*/ ,
                            v3 /*: any*/ ,
                            {
                                "concreteType": "ConfluencePageLinks",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": false,
                                "selections": v4 /*: any*/ 
                            }
                        ],
                        "type": "ConfluencePage"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v0 /*: any*/ ,
                            v3 /*: any*/ ,
                            {
                                "concreteType": "ConfluenceWhiteboardLinks",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": false,
                                "selections": v4 /*: any*/ 
                            }
                        ],
                        "type": "ConfluenceWhiteboard"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v0 /*: any*/ ,
                            v3 /*: any*/ ,
                            {
                                "concreteType": "ConfluenceDatabaseLinks",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": false,
                                "selections": v4 /*: any*/ 
                            }
                        ],
                        "type": "ConfluenceDatabase"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v0 /*: any*/ ,
                            v3 /*: any*/ ,
                            {
                                "concreteType": "ConfluenceSlideLinks",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": false,
                                "selections": v4 /*: any*/ 
                            }
                        ],
                        "type": "ConfluenceSlide"
                    }
                ]
            }
        ],
        "type": "AgentSession"
    };
}();
$5581ee50265daf0c$var$node.hash = "ac819ea638c093fdadc1ddaa95090995";
var $5581ee50265daf0c$export$2e2bcd8739ae039 = $5581ee50265daf0c$var$node;
module.exports["default"] = $5581ee50265daf0c$export$2e2bcd8739ae039;

});

parcelRegister("iQweE", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $dcdb8a6b0c5907f3$export$a0ac8db0953e5980 = 25;
const $dcdb8a6b0c5907f3$export$879fcbb723a9ff07 = 'lastStateChangeAt DESC';
const $dcdb8a6b0c5907f3$export$41ea36d080f9470 = 259200000;
let $dcdb8a6b0c5907f3$var$pagePolicy;
const $dcdb8a6b0c5907f3$export$f0ee6b6d3a78c8e6 = ()=>{
    const read = ()=>({
            includeLocalAgentSessions: (0, $iDrrr.fg)('rovo_chat_all_chats_local_agent_sessions')
        });
    // Server requests must not share a user's gate evaluation.
    if (typeof window === 'undefined') return read();
    return $dcdb8a6b0c5907f3$var$pagePolicy ?? ($dcdb8a6b0c5907f3$var$pagePolicy = read());
};
const $dcdb8a6b0c5907f3$export$d87f59ee5a35261f = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'");
module.exports["AGENT_SESSIONS_PAGE_SIZE"] = $dcdb8a6b0c5907f3$export$a0ac8db0953e5980;
module.exports["AGENT_SESSIONS_SORT"] = $dcdb8a6b0c5907f3$export$879fcbb723a9ff07;
module.exports["UNSEEN_WINDOW_MS"] = $dcdb8a6b0c5907f3$export$41ea36d080f9470;
module.exports["getAgentSessionsPolicy"] = $dcdb8a6b0c5907f3$export$f0ee6b6d3a78c8e6;

});

parcelRegister("fzdMm", function(module, exports) {

var $jgPA1 = parcelRequire("jgPA1");


var $6SsN4 = parcelRequire("6SsN4");

const $7b73751480850907$var$cloudIdsByEnvironment = new WeakMap();
const $7b73751480850907$var$getCloudIdCache = (environment)=>{
    let cache = $7b73751480850907$var$cloudIdsByEnvironment.get(environment);
    if (cache == null) {
        cache = new Map();
        $7b73751480850907$var$cloudIdsByEnvironment.set(environment, cache);
    }
    return cache;
};
const $7b73751480850907$var$getNonEmptyCloudIds = (tenantContexts)=>{
    return Array.from(new Set(tenantContexts?.map((tenantContext)=>tenantContext?.cloudId?.trim()).filter((cloudId)=>cloudId != null && cloudId.length > 0) ?? []));
};
const $7b73751480850907$export$f95ed6f15546b5c1 = (environment, { rovoActivationId: rovoActivationId, onComplete: onComplete })=>{
    const cache = $7b73751480850907$var$getCloudIdCache(environment);
    const cachedCloudId = cache.get(rovoActivationId);
    if (cachedCloudId != null) {
        onComplete({
            cloudId: cachedCloudId
        });
        return {
            dispose: ()=>{}
        };
    }
    let disposed = false;
    const subscription = (0, $6SsN4.fetchQuery)(environment, (0, $jgPA1.default), {
        rovoActivationId: rovoActivationId
    }, {
        fetchPolicy: 'network-only'
    }).subscribe({
        next: (data)=>{
            if (disposed) return;
            const cloudIds = $7b73751480850907$var$getNonEmptyCloudIds(data.tenantContexts);
            if (cloudIds.length !== 1) {
                onComplete({
                    error: new Error('Expected one cloud ID for the Rovo activation.')
                });
                return;
            }
            cache.set(rovoActivationId, cloudIds[0]);
            onComplete({
                cloudId: cloudIds[0]
            });
        },
        error: (error)=>{
            if (!disposed) onComplete({
                error: error
            });
        }
    });
    return {
        dispose: ()=>{
            disposed = true;
            subscription.unsubscribe();
        }
    };
};
module.exports["resolveAgentSessionsCloudId"] = $7b73751480850907$export$f95ed6f15546b5c1;

});

parcelRegister("jgPA1", function(module, exports) {
/**
 * @generated SignedSource<<6238c59b75c7f7e374637ad65ce91807>>
 * @relayHash 9a9c9f71797c041d0234557239b4c6e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID df63ac7e0295bff036a9dcf0ca3e6bccd2bacc6c42e043cc7b0ee7d7b6ade4ad
const $1e6683b12f40c1e8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "rovoActivationId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "activationIds.0",
                            "variableName": "rovoActivationId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "activationIds"
                }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "cloudId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "resolveAgentSessionsCloudIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "resolveAgentSessionsCloudIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "df63ac7e0295bff036a9dcf0ca3e6bccd2bacc6c42e043cc7b0ee7d7b6ade4ad",
            "metadata": {},
            "name": "resolveAgentSessionsCloudIdQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1e6683b12f40c1e8$var$node.hash = "c31ba1b82eb0966659d0b2058ab65de0";
var $1e6683b12f40c1e8$export$2e2bcd8739ae039 = $1e6683b12f40c1e8$var$node;
module.exports["default"] = $1e6683b12f40c1e8$export$2e2bcd8739ae039;

});

parcelRegister("8zLKj", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $dedf874fb91d7b78$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    compactMinute: {
        id: "rovo-platform-ui-components.session-details.compact-minute.ai-non-final",
        defaultMessage: "{value, number}m"
    },
    compactHour: {
        id: "rovo-platform-ui-components.session-details.compact-hour.ai-non-final",
        defaultMessage: "{value, number}h"
    },
    compactDay: {
        id: "rovo-platform-ui-components.session-details.compact-day.ai-non-final",
        defaultMessage: "{value, number}d"
    },
    compactWeek: {
        id: "rovo-platform-ui-components.session-details.compact-week.ai-non-final",
        defaultMessage: "{value, number}w"
    },
    compactYear: {
        id: "rovo-platform-ui-components.session-details.compact-year.ai-non-final",
        defaultMessage: "{value, number}y"
    },
    inProgress: {
        id: "rovo-platform-ui-components.session-details.inProgress",
        defaultMessage: "In progress"
    },
    working: {
        id: "rovo-platform-ui-components.session-details.working",
        defaultMessage: "Working"
    },
    unreadSessionLabel: {
        // eslint-disable-next-line @atlassian/i18n/enforce-id-by-package -- Preserve the existing translation when extracting the unread indicator.
        id: "ai-inbox.unreadSessionLabel",
        defaultMessage: "Unread agent session"
    },
    needsInput: {
        id: "rovo-platform-ui-components.session-details.needs-input",
        defaultMessage: "Needs input"
    },
    rovoIsThinking: {
        id: "rovo-platform-ui-components.session-details.rovo-is-thinking",
        defaultMessage: "Rovo is thinking..."
    },
    agentIsThinking: {
        id: "rovo-platform-ui-components.session-details.agent-is-thinking",
        defaultMessage: "Agent is thinking..."
    },
    additionalAgents: {
        id: "rovo-platform-ui-components.session-details.additional-agents",
        defaultMessage: "+{count} more"
    },
    additionalAgentsLabel: {
        id: "rovo-platform-ui-components.session-details.additional-agents-label",
        defaultMessage: "{count} more agents"
    },
    contextsLabel: {
        id: "rovo-platform-ui-components.session-details.contextsLabel",
        defaultMessage: "Session contexts"
    },
    additionalContexts: {
        id: "rovo-platform-ui-components.session-details.additionalContexts",
        defaultMessage: "+{count}"
    },
    additionalContextsLabel: {
        id: "rovo-platform-ui-components.session-details.additionalContextsLabel",
        defaultMessage: "{count, plural, one {# more context item} other {# more context items}}"
    }
});
module.exports["messages"] = $dedf874fb91d7b78$export$defe85febe8b728c;

});

parcelRegister("3XWVS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $8zLKj = parcelRequire("8zLKj");

const $a9ebde6d5ac68c90$var$styles = {
    lastUpdated: "_3YEZNOdnbC"
};
const $a9ebde6d5ac68c90$var$COMPACT_TIME_UNITS = [
    [
        (0, $8zLKj.messages).compactYear,
        31536000000
    ],
    [
        (0, $8zLKj.messages).compactWeek,
        604800000
    ],
    [
        (0, $8zLKj.messages).compactDay,
        86400000
    ],
    [
        (0, $8zLKj.messages).compactHour,
        3600000
    ],
    [
        (0, $8zLKj.messages).compactMinute,
        60000
    ]
];
const $a9ebde6d5ac68c90$var$RelativeSessionTime = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { timestamp: timestamp } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const now = Date.now();
    const elapsed = Math.abs(now - timestamp);
    let t1;
    if ($[0] !== elapsed || $[1] !== formatMessage) {
        const [message, milliseconds] = $a9ebde6d5ac68c90$var$COMPACT_TIME_UNITS.find((t2)=>{
            const [, unitMilliseconds] = t2;
            return elapsed >= unitMilliseconds;
        }) ?? [
            (0, $8zLKj.messages).compactMinute,
            60000
        ];
        const value = Math.max(1, Math.floor(elapsed / milliseconds));
        t1 = formatMessage(message, {
            value: value
        });
        $[0] = elapsed;
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ timestamp: timestamp })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const now = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>Date.now(), []);
    const elapsed = Math.abs(now - timestamp);
    const [message, milliseconds] = $a9ebde6d5ac68c90$var$COMPACT_TIME_UNITS.find(([, unitMilliseconds])=>elapsed >= unitMilliseconds) ?? [
        (0, $8zLKj.messages).compactMinute,
        60000
    ];
    const value = Math.max(1, Math.floor(elapsed / milliseconds));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, formatMessage(message, {
        value: value
    }));
};
const $a9ebde6d5ac68c90$export$27e179c7a0252422 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { lastStateChangeAt: lastStateChangeAt, lastUpdated: lastUpdated, testId: testId } = t0;
    let t1;
    if ($[0] !== lastStateChangeAt || $[1] !== lastUpdated) {
        t1 = lastStateChangeAt != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a9ebde6d5ac68c90$var$RelativeSessionTime, {
            timestamp: lastStateChangeAt
        }) : lastUpdated;
        $[0] = lastStateChangeAt;
        $[1] = lastUpdated;
        $[2] = t1;
    } else t1 = $[2];
    const content = t1;
    if (content === undefined || content === null || content === false) return null;
    let t2;
    if ($[3] !== content || $[4] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $a9ebde6d5ac68c90$var$styles.lastUpdated,
            testId: testId
        }, content);
        $[3] = content;
        $[4] = testId;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ lastStateChangeAt: lastStateChangeAt, lastUpdated: lastUpdated, testId: testId })=>{
    const content = lastStateChangeAt != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a9ebde6d5ac68c90$var$RelativeSessionTime, {
        timestamp: lastStateChangeAt
    }) : lastUpdated;
    if (content === undefined || content === null || content === false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $a9ebde6d5ac68c90$var$styles.lastUpdated,
        testId: testId
    }, content);
};
module.exports["SessionLastUpdated"] = $a9ebde6d5ac68c90$export$27e179c7a0252422;

});

parcelRegister("4Rua2", function(module, exports) {

var $5sAZN = parcelRequire("5sAZN");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $bJzbV = parcelRequire("bJzbV");


var $lvIcu = parcelRequire("lvIcu");


var $2kPmq = parcelRequire("2kPmq");

const $9ccfea8e4bdc54f1$export$66dfd1d2f159b56f = (0, $5sAZN.default);
// The lookup takes the server session ID, not its ARI or Relay's normalized record ID.
const $9ccfea8e4bdc54f1$var$variablesFor = (scope, sessionId)=>({
        sharingContext: scope.workspaceAri,
        sessionId: sessionId
    });
const $9ccfea8e4bdc54f1$export$f109cad329d3cee6 = (environment, scope, sessionId)=>{
    const operation = (0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)($9ccfea8e4bdc54f1$export$66dfd1d2f159b56f), $9ccfea8e4bdc54f1$var$variablesFor(scope, sessionId));
    const selector = (0, $eqEJl.createReaderSelector)((0, $eqEJl.getFragment)((0, $lvIcu.agentSessionSnapshot)), (0, $bJzbV.default)({
        id: sessionId
    }, 'AgentSession'), operation.request.variables, operation.request);
    return environment.lookup(selector);
};
const $9ccfea8e4bdc54f1$var$requests = new WeakMap();
const $9ccfea8e4bdc54f1$export$a1a6d296cc8bb6e0 = (environment, scope, sessionId, onComplete)=>{
    let pending = $9ccfea8e4bdc54f1$var$requests.get(environment);
    if (!pending) {
        pending = new Map();
        $9ccfea8e4bdc54f1$var$requests.set(environment, pending);
    }
    const key = JSON.stringify([
        (0, $2kPmq.getAgentSessionsScopeKey)(scope),
        sessionId
    ]);
    let job = pending.get(key);
    if (!job) {
        const variables = $9ccfea8e4bdc54f1$var$variablesFor(scope, sessionId);
        const operation = (0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)($9ccfea8e4bdc54f1$export$66dfd1d2f159b56f), variables);
        const retention = environment.retain(operation);
        let network;
        let finished = false;
        let found = false;
        const listeners = new Set([
            onComplete
        ]);
        job = {
            listeners: listeners,
            dispose: ()=>{
                network?.unsubscribe();
                retention.dispose();
            }
        };
        const current = job;
        pending.set(key, current);
        const finish = (error)=>{
            if (finished) return;
            finished = true;
            pending?.delete(key);
            try {
                current.listeners.forEach((listener)=>listener({
                        found: found,
                        error: error
                    }));
            } finally{
                current.dispose();
            }
        };
        network = (0, $6SsN4.fetchQuery)(environment, $9ccfea8e4bdc54f1$export$66dfd1d2f159b56f, variables, {
            fetchPolicy: 'network-only'
        }).subscribe({
            next: (data)=>{
                found = data.agent_sessionGetById?.id === sessionId;
            },
            error: (error)=>finish(error),
            complete: ()=>finish(null)
        });
    } else job.listeners.add(onComplete);
    const current = job;
    return {
        dispose: ()=>{
            current.listeners.delete(onComplete);
            if (!current.listeners.size && pending?.get(key) === current) {
                pending.delete(key);
                current.dispose();
            }
        }
    };
};
module.exports["readAgentSessionDisplay"] = $9ccfea8e4bdc54f1$export$f109cad329d3cee6;
module.exports["hydrateAgentSession"] = $9ccfea8e4bdc54f1$export$a1a6d296cc8bb6e0;

});

parcelRegister("5sAZN", function(module, exports) {
/**
 * @generated SignedSource<<de45414f9af3d525362285e11044d018>>
 * @relayHash f444ddc6ade05d93f1f2cc262d2168e5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5ac1e7c1a00984b30e84c8049faac8493ed349bc8015debf0791d15184303907
const $5c5520efb0f3d0d9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sessionId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sharingContext"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "sessionId"
        },
        {
            "kind": "Variable",
            "name": "shardingContext",
            "variableName": "sharingContext"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "hasUnseenActivity"
    }, v4 = {
        "kind": "ScalarField",
        "name": "invocationType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "state"
    }, v7 = {
        "kind": "ScalarField",
        "name": "stateReason"
    }, v8 = {
        "kind": "ScalarField",
        "name": "expireTime"
    }, v9 = {
        "kind": "ScalarField",
        "name": "lastStateChangeAt"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isRovo"
    }, v11 = {
        "kind": "ScalarField",
        "name": "agentAccountId"
    }, v12 = {
        "kind": "ScalarField",
        "name": "convoAiAgentId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = {
        "alias": "conversationChannel",
        "concreteType": "AgentConversationChannel",
        "kind": "LinkedField",
        "name": "nativeConversationChannel",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "createdAt"
            },
            {
                "kind": "ScalarField",
                "name": "interactionChannel"
            },
            {
                "kind": "ScalarField",
                "name": "interactionChannelAri"
            },
            {
                "kind": "ScalarField",
                "name": "rawAgent"
            },
            {
                "kind": "ScalarField",
                "name": "rawScopes"
            },
            {
                "kind": "ScalarField",
                "name": "rawParticipants"
            },
            {
                "kind": "ScalarField",
                "name": "rawAgentAuthor"
            },
            v13 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "lastMessage"
            },
            {
                "kind": "ScalarField",
                "name": "lastMessageTimestamp"
            },
            {
                "kind": "ScalarField",
                "name": "lastMessageType"
            },
            {
                "kind": "ScalarField",
                "name": "lastAgentMessageId"
            },
            {
                "kind": "ScalarField",
                "name": "lastAgentMessageStatus"
            },
            {
                "kind": "ScalarField",
                "name": "readStatus"
            },
            {
                "kind": "ScalarField",
                "name": "isPlanning"
            },
            {
                "kind": "ScalarField",
                "name": "isPinned"
            },
            {
                "kind": "ScalarField",
                "name": "pinnedAt"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v16 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v17 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "webUrl"
            }
        ],
        "type": "JiraIssue"
    }, v19 = {
        "kind": "ScalarField",
        "name": "title"
    }, v20 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v21 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ ,
            v19 /*: any*/ ,
            {
                "concreteType": "ConfluencePageLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v20 /*: any*/ 
            }
        ],
        "type": "ConfluencePage"
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ ,
            v19 /*: any*/ ,
            {
                "concreteType": "ConfluenceWhiteboardLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v20 /*: any*/ 
            }
        ],
        "type": "ConfluenceWhiteboard"
    }, v23 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ ,
            v19 /*: any*/ ,
            {
                "concreteType": "ConfluenceDatabaseLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v20 /*: any*/ 
            }
        ],
        "type": "ConfluenceDatabase"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ ,
            v19 /*: any*/ ,
            {
                "concreteType": "ConfluenceSlideLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v20 /*: any*/ 
            }
        ],
        "type": "ConfluenceSlide"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "agentSessionHydrationQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "AgentSession",
                    "kind": "LinkedField",
                    "name": "agent_sessionGetById",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v14 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "agent",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                v13 /*: any*/ ,
                                v16 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "studioAgent",
                            "plural": false,
                            "selections": [
                                v13 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "associatedEntities",
                            "plural": true,
                            "selections": [
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "agentSessionHydrationQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "AgentSession",
                    "kind": "LinkedField",
                    "name": "agent_sessionGetById",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v14 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "agent",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                v15 /*: any*/ ,
                                v13 /*: any*/ ,
                                v16 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                v15 /*: any*/ ,
                                v13 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "studioAgent",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                v13 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "associatedEntities",
                            "plural": true,
                            "selections": [
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5ac1e7c1a00984b30e84c8049faac8493ed349bc8015debf0791d15184303907",
            "metadata": {},
            "name": "agentSessionHydrationQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5c5520efb0f3d0d9$var$node.hash = "eb2c87a845b637cccae43723519b7277";
var $5c5520efb0f3d0d9$export$2e2bcd8739ae039 = $5c5520efb0f3d0d9$var$node;
module.exports["default"] = $5c5520efb0f3d0d9$export$2e2bcd8739ae039;

});

parcelRegister("bRRZQ", function(module, exports) {
const $6f0ca15701340913$export$ed3f201f5b820949 = (accountId, rovoActivationId, includeLocalAgentSessions = false)=>{
    const rovoWorkspaceAri = `ari:cloud:rovo::workspace/${rovoActivationId}`;
    const escapedAccountId = accountId.replace(/\\/g, '\\\\').replace(/'/g, "\\'");
    return {
        sharingContext: rovoWorkspaceAri,
        aqlQuery: includeLocalAgentSessions ? `authorAccountId = '${escapedAccountId}'` : `authorAccountId = '${escapedAccountId}' AND invocationType <> 'LOCAL_AGENT_SESSION'`
    };
};
module.exports["createAgentSessionsQueryInputs"] = $6f0ca15701340913$export$ed3f201f5b820949;

});

parcelRegister("iVGmD", function(module, exports) {

var $eqEJl = parcelRequire("eqEJl");

const $b5c2724d41c46322$var$isObject = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value);
const $b5c2724d41c46322$var$isUsableList = (connection)=>{
    if (!$b5c2724d41c46322$var$isObject(connection) || !Array.isArray(connection.edges)) return false;
    const { pageInfo: pageInfo } = connection;
    return $b5c2724d41c46322$var$isObject(pageInfo) && typeof pageInfo.hasNextPage === 'boolean' && (typeof pageInfo.endCursor === 'string' || pageInfo.endCursor === null) && (!pageInfo.hasNextPage || typeof pageInfo.endCursor === 'string') && connection.edges.every((edge)=>edge === null || $b5c2724d41c46322$var$isObject(edge) && (typeof edge.cursor === 'string' || edge.cursor === null) && (edge.node === null || $b5c2724d41c46322$var$isObject(edge.node) && typeof edge.node.id === 'string'));
};
const $b5c2724d41c46322$export$94493c643209b93f = (environment, query, variables, onComplete, shape = 'edges')=>{
    const operation = (0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)(query), variables, {
        force: true
    });
    const source = (0, $eqEJl.Observable).create((sink)=>{
        let response;
        const network = environment.getNetwork().execute(operation.request.node.params, operation.request.variables, {
            force: true
        }).subscribe({
            next: (payload)=>{
                if (Array.isArray(payload)) {
                    sink.error(new Error('Unexpected batched session response'));
                    return;
                }
                const next = payload;
                const errors = 'errors' in next ? next.errors : undefined;
                if ('path' in next || 'label' in next || 'incremental' in next) {
                    sink.error(new Error('Incomplete session response'));
                    return;
                }
                if (response && next.data == null && !errors?.length && next.extensions?.is_final === true) return;
                const connection = next.data?.agent_sessionQuery;
                // Nullable display relationships may fail independently of a usable list.
                // Status has no such relationships, so retain its strict error handling.
                const usable = shape === 'edges' ? $b5c2724d41c46322$var$isUsableList(connection) : !errors?.length && $b5c2724d41c46322$var$isObject(connection) && Array.isArray(connection.nodes);
                if (response || !usable) {
                    sink.error(new Error(errors?.map((error)=>error.message).join('; ') || 'Expected one complete session connection'));
                    return;
                }
                if (shape === 'edges' && variables.after != null && $b5c2724d41c46322$var$isObject(connection) && $b5c2724d41c46322$var$isObject(connection.pageInfo) && connection.pageInfo.hasNextPage && connection.pageInfo.endCursor === variables.after) {
                    sink.error(new Error('AgentSession pagination did not advance its cursor.'));
                    return;
                }
                response = next;
            },
            error: (error)=>sink.error(error),
            complete: ()=>{
                if (response) {
                    sink.next(response);
                    sink.complete();
                } else sink.error(new Error('Missing session response'));
            }
        });
        return ()=>{
            response = undefined;
            network.unsubscribe();
        };
    });
    const request = environment.executeWithSource({
        operation: operation,
        source: source
    }).subscribe({
        complete: ()=>onComplete(null),
        error: onComplete
    });
    return {
        dispose: ()=>{
            request.unsubscribe();
        }
    };
};
module.exports["refreshSharedAgentSessions"] = $b5c2724d41c46322$export$94493c643209b93f;

});

parcelRegister("k4WnC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

class $567ca90230477fc4$export$3b09d2662dd82e73 {
    update(update) {
        this.snapshot = {
            ...this.snapshot,
            ...update
        };
        this.listeners.forEach((listener)=>listener());
    }
    acquire(reader) {
        this.readers.add(reader);
        if (!this.snapshot.owner) this.update({
            owner: reader,
            generation: this.snapshot.generation + 1,
            error: null
        });
        let released = false;
        return ()=>{
            if (released) return;
            released = true;
            this.readers.delete(reader);
            if (this.snapshot.owner === reader) this.update({
                owner: this.readers.values().next().value ?? null,
                generation: this.snapshot.generation + 1
            });
        };
    }
    publish(owner, generation, value) {
        if (this.snapshot.owner !== owner || this.snapshot.generation !== generation) return;
        this.update({
            value: value,
            error: null
        });
    }
    fail(owner, generation, error) {
        if (this.snapshot.owner !== owner || this.snapshot.generation !== generation) return;
        this.update({
            error: error
        });
    }
    clear() {
        this.update({
            value: null,
            error: null
        });
    }
    owns(owner, generation) {
        return this.snapshot.owner === owner && this.snapshot.generation === generation;
    }
    constructor(){
        this.readers = new Set();
        this.listeners = new Set();
        this.snapshot = {
            owner: null,
            generation: 0,
            value: null,
            error: null
        };
        this.getSnapshot = ()=>this.snapshot;
        this.subscribe = (listener)=>{
            this.listeners.add(listener);
            return ()=>{
                this.listeners.delete(listener);
            };
        };
    }
}
const $567ca90230477fc4$export$588ec9359de2b00e = (resource, active = true)=>{
    const [reader] = (0, $cozmU.useState)(()=>Symbol('agent-sessions-reader'));
    const snapshot = (0, $cozmU.useSyncExternalStore)(resource.subscribe, resource.getSnapshot, resource.getSnapshot);
    (0, $cozmU.useEffect)(()=>active ? resource.acquire(reader) : undefined, [
        active,
        reader,
        resource
    ]);
    return {
        ...snapshot,
        reader: reader,
        isOwner: active && snapshot.owner === reader
    };
};
module.exports["SharedAgentSessionsResource"] = $567ca90230477fc4$export$3b09d2662dd82e73;
module.exports["useSharedAgentSessionsResource"] = $567ca90230477fc4$export$588ec9359de2b00e;

});

parcelRegister("cmegX", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $hlvTd = parcelRequire("hlvTd");

const $53153ceda3a05e96$var$AGENT_SESSION_STATE_VALUES = new Set([
    'WORKING',
    'INPUT_REQUIRED',
    'ARTEFACT_READY',
    'AUTH_REQUIRED',
    'FAILED',
    'REJECTED',
    'COMPLETED',
    'CANCELLED',
    'UNKNOWN'
]);
const $53153ceda3a05e96$var$isAgentSessionState = (value)=>$53153ceda3a05e96$var$AGENT_SESSION_STATE_VALUES.has(value);
const $53153ceda3a05e96$var$getHttpUrl = (value, base)=>{
    if (!value?.trim()) return undefined;
    try {
        const url = new URL(value.trim(), base?.trim() || undefined);
        return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : undefined;
    } catch  {
        return undefined;
    }
};
const $53153ceda3a05e96$var$getConversationChannel = (channel)=>{
    if (channel == null) return undefined;
    return {
        ...channel.id == null ? {} : {
            id: channel.id
        },
        ...channel.name == null ? {} : {
            name: channel.name
        },
        ...channel.createdAt === undefined ? {} : {
            createdAt: channel.createdAt
        },
        ...channel.interactionChannel === undefined ? {} : {
            interactionChannel: channel.interactionChannel
        },
        ...channel.interactionChannelAri === undefined ? {} : {
            interactionChannelAri: channel.interactionChannelAri
        },
        ...channel.rawAgent === undefined ? {} : {
            rawAgent: channel.rawAgent
        },
        ...channel.rawScopes === undefined ? {} : {
            rawScopes: channel.rawScopes
        },
        ...channel.rawParticipants === undefined ? {} : {
            rawParticipants: channel.rawParticipants
        },
        ...channel.rawAgentAuthor === undefined ? {} : {
            rawAgentAuthor: channel.rawAgentAuthor
        },
        ...channel.lastAgentMessageId === undefined ? {} : {
            lastAgentMessageId: channel.lastAgentMessageId
        },
        ...channel.lastAgentMessageStatus === undefined ? {} : {
            lastAgentMessageStatus: channel.lastAgentMessageStatus
        },
        ...channel.lastMessage === undefined ? {} : {
            lastMessage: channel.lastMessage
        },
        ...channel.lastMessageTimestamp === undefined ? {} : {
            lastMessageTimestamp: channel.lastMessageTimestamp
        },
        ...channel.lastMessageType === undefined ? {} : {
            lastMessageType: channel.lastMessageType
        },
        ...channel.pinnedAt === undefined ? {} : {
            pinnedAt: channel.pinnedAt
        },
        ...channel.status === undefined ? {} : {
            status: channel.status
        },
        ...channel.readStatus === undefined ? {} : {
            readStatus: channel.readStatus
        },
        ...channel.isPinned === undefined ? {} : {
            isPinned: channel.isPinned
        },
        ...channel.isPlanning === undefined ? {} : {
            isPlanning: channel.isPlanning
        }
    };
};
const $53153ceda3a05e96$var$getDisplayAgent = (session, sessionId)=>{
    if (session.agent != null) return {
        id: session.agent.accountId,
        name: session.agent.name,
        ...session.agent.picture ? {
            avatarUrl: session.agent.picture
        } : {},
        ...session.isRovo == null ? {} : {
            isRovo: session.isRovo
        },
        ...session.convoAiAgentId == null ? {} : {
            agentId: session.convoAiAgentId
        },
        ...session.agentAccountId == null ? {} : {
            agentIdentityAccountId: session.agentAccountId
        }
    };
    if (session.studioAgent?.name != null) return {
        id: session.convoAiAgentId ?? session.agentAccountId ?? sessionId,
        name: session.studioAgent.name,
        ...session.isRovo == null ? {} : {
            isRovo: session.isRovo
        },
        ...session.convoAiAgentId == null ? {} : {
            agentId: session.convoAiAgentId
        },
        ...session.agentAccountId == null ? {} : {
            agentIdentityAccountId: session.agentAccountId
        }
    };
    return undefined;
};
const $53153ceda3a05e96$var$CONFLUENCE_CONTENT_SUBTYPES = {
    ConfluencePage: 'page',
    ConfluenceWhiteboard: 'whiteboard',
    ConfluenceDatabase: 'database',
    ConfluenceSlide: 'slide'
};
const $53153ceda3a05e96$var$getContexts = (session)=>{
    const contexts = session.associatedEntities?.flatMap((entity)=>{
        if (entity?.__typename === 'JiraIssue') {
            const issueKey = entity.key?.trim();
            const url = $53153ceda3a05e96$var$getHttpUrl(entity.webUrl);
            return issueKey && url ? [
                {
                    id: entity.id,
                    label: issueKey,
                    type: 'jira',
                    url: url
                }
            ] : [];
        }
        if (entity?.__typename === 'ConfluencePage' || (entity?.__typename === 'ConfluenceWhiteboard' || entity?.__typename === 'ConfluenceDatabase' || entity?.__typename === 'ConfluenceSlide') && (0, $iDrrr.fg)('rovo_agent_session_content_types')) {
            const title = entity.title?.trim();
            const base = entity.links?.base?.trim();
            const webUi = entity.links?.webUi?.trim();
            const url = (0, $iDrrr.fg)('rovo_agent_session_content_types') && base && webUi?.startsWith('/') ? $53153ceda3a05e96$var$getHttpUrl(`${base.replace(/\/$/, '')}${webUi}`) : $53153ceda3a05e96$var$getHttpUrl(webUi, base);
            if (!title || !url) return [];
            return [
                {
                    id: entity.id,
                    label: title,
                    type: 'confluence',
                    url: url,
                    subtype: $53153ceda3a05e96$var$CONFLUENCE_CONTENT_SUBTYPES[entity.__typename]
                }
            ];
        }
        return [];
    });
    return contexts?.length ? contexts : undefined;
};
const $53153ceda3a05e96$export$1d573590a6950c38 = (session)=>{
    if (session.id == null) return null;
    const conversationChannel = $53153ceda3a05e96$var$getConversationChannel(session.conversationChannel);
    const title = conversationChannel?.name?.trim();
    const readStatus = conversationChannel?.readStatus;
    const state = session.state ?? undefined;
    if (state != null && !$53153ceda3a05e96$var$isAgentSessionState(state)) (0, $hlvTd.logSentryConsoleWarning)('Unknown agent session state returned by AgentSessions API:', state);
    const displayAgent = $53153ceda3a05e96$var$getDisplayAgent(session, session.id);
    const contexts = $53153ceda3a05e96$var$getContexts(session);
    const legacyContext = contexts?.[0]?.label.trim();
    return {
        id: session.id,
        raw: session,
        hasConversation: conversationChannel != null,
        ...session.lastStateChangeAt == null ? {} : {
            lastStateChangeAt: session.lastStateChangeAt
        },
        ...state == null ? {} : {
            state: state
        },
        ...session.stateReason === undefined ? {} : {
            stateReason: session.stateReason
        },
        ...conversationChannel == null ? {} : {
            conversationChannel: conversationChannel
        },
        ...conversationChannel?.id == null ? {} : {
            conversationId: conversationChannel.id
        },
        ...title ? {
            title: title
        } : {},
        ...readStatus == null ? {} : {
            isUnread: !readStatus
        },
        ...session.conversationChannel?.lastAgentMessageStatus === 'IN_PROGRESS' ? {
            isInProgress: true
        } : {},
        ...state == null ? {} : {
            requiresInput: state === 'INPUT_REQUIRED' || state === 'AUTH_REQUIRED'
        },
        ...displayAgent == null ? {} : {
            displayAgent: displayAgent
        },
        ...contexts == null ? {} : {
            contexts: contexts
        },
        ...legacyContext ? {
            context: legacyContext
        } : {}
    };
};
module.exports["normalizeAgentSession"] = $53153ceda3a05e96$export$1d573590a6950c38;

});


//# sourceMappingURL=main.fb10c21c.js.map
